import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{attrs:{"outlined":"","tile":""}},[_c(VCardText,[_c('strong',[_vm._v(_vm._s(_vm.name))])]),_c('hr',{staticClass:"m-0"}),_c(VCardTitle,[_c('h4',[_vm._v(_vm._s(_vm.data.count))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }